import store from "@/store";

function currentloglevel(){
    let current =  store.getters['logging/logLevel']    
    return current
}

function currentlogstack(){
    let stack = store.getters['logging/logstack']
    return stack
}

class ErrorService {
    static SEVERE = 100;
    static ERROR = 200;
    static WARN = 300;
    static INFO = 400;
    static DEBUG = 500;
    static TRACE = 600;
    
    
    constructor(){
        // this.initHandler();
    }

    static levels = [
        { level: ErrorService.SEVERE, name: 'Severe'},
        { level: ErrorService.ERROR, name: 'Error'},
        { level: ErrorService.WARN, name: 'Warn'},
        { level: ErrorService.INFO, name: 'Info'},
        { level: ErrorService.DEBUG, name: 'Debug'},
        { level: ErrorService.TRACE, name: 'Trace'},
    ]

    static isSevereEnabled(){
        return currentloglevel() >= ErrorService.SEVERE;
    }
    static isErrorEnabled(){
        return currentloglevel() >= ErrorService.ERROR;
    }
    static isWarnEnabled(){
        return currentloglevel() >= ErrorService.WARN;
    }
    static isInfoEnabled(){
        return currentloglevel() >= ErrorService.INFO;
    }
    static isDebugEnabled(){
        return currentloglevel() >= ErrorService.DEBUG;
    }
    static isTraceEnabled(){
        return currentloglevel() >= ErrorService.TRACE;
    }


    static onSevere(message) {
        if (this.isSevereEnabled())
            ErrorService.logMessage("SEVERE", message)
    }

    static onError(message) {
        if (this.isErrorEnabled())
            ErrorService.logMessage("ERROR", message)
    }

    static onWarn(message) {
        if (this.isWarnEnabled())
            ErrorService.logMessage("WARN", message)
    }

    static onInfo(message){
        if (this.isInfoEnabled())
            ErrorService.logMessage("INFO", message)      
    }

    static onDebug(message) {
        if (this.isDebugEnabled()) {
            ErrorService.logMessage("DEBUG", message)
            if ( currentlogstack())
              console.log(new Error().stack)
        }
    }

    static onTrace(message) {
        if (this.isTraceEnabled()) {
            ErrorService.logMessage("TRACE", message)
            if ( currentlogstack())
              console.log(new Error().stack)
        }
    }

    static logMessage(name, message){
      console.log(name + ': '  + message)
    }

    static initHandler() {
        // install an error handler to catch window errors
        const scope = this;
        window.onerror = (message, url, lineNo, columnNo, error) => {
            if ( error) {
                scope.onError(error)
                console.log(message, url, lineNo, columnNo, error);
            }
        }
    }
}


const ErrorPlugin = {
    install(Vue, options) {
      Vue.prototype.$log = ErrorService
    },
}

export {
    ErrorService,
    ErrorPlugin
}